const normalizeHours = (hours = {}) => {
  const start = Number.isInteger(hours.auto_start_hour) ? hours.auto_start_hour : 19;
  const end = Number.isInteger(hours.auto_end_hour) ? hours.auto_end_hour : 6;
  return { start, end };
};

const isInDarkWindow = (start, end, now = new Date()) => {
  const hour = now.getHours();
  const overnight = start > end;
  if (start === end) return false;
  return overnight ? (hour >= start || hour < end) : (hour >= start && hour < end);
};

const normalizeThemePreference = (value = 'auto') => {
  if (value === 'christmas') return 'light'; // legacy fallback
  return ['auto', 'light', 'dark'].includes(value) ? value : 'auto';
};

export const applyThemePreference = (themePreference = 'auto', hours = {}) => {
  const normalizedTheme = normalizeThemePreference(themePreference);
  const { start, end } = normalizeHours(hours);
  const inDarkWindow = isInDarkWindow(start, end);
  let useDark = false;
  if (normalizedTheme === 'dark') useDark = true;
  else if (normalizedTheme === 'light') useDark = false;
  else useDark = inDarkWindow; // auto

  const root = document.documentElement;
  root.classList.toggle('dark', useDark);

  try { localStorage.setItem('theme', normalizedTheme); } catch (_) {}
  return useDark;
};

export const getStoredThemePreference = () => {
  try {
    const stored = localStorage.getItem('theme');
    return normalizeThemePreference(stored || 'auto');
  } catch (_) { return 'auto'; }
};

export const applySnowPreference = (enabled = false) => {
  const root = document.documentElement;
  root.classList.toggle('snowfall', !!enabled);
  try { localStorage.setItem('snowEnabled', enabled ? 'true' : 'false'); } catch (_) {}
};

export const getStoredSnowPreference = () => {
  try {
    const stored = localStorage.getItem('snowEnabled');
    if (stored === null) {
      // Legacy christmas theme should enable snow by default
      return localStorage.getItem('theme') === 'christmas';
    }
    return stored === 'true';
  } catch (_) { return false; }
};
